import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      operatingSurgeon: 'Operating Surgeon',
      hospitalNameAsPerLicense: 'Hospital Name (As per License) ',
      settlementBankDetails: 'Settlement Bank Details',
      accountHolderName: 'Account Holder Name',
      accountNumber: 'Account Number',
      bankName: 'Bank Name',
      ifscCode: 'IFSC Code',
      uploadBankProof: 'Upload Cancelled Cheque / Passbook Copy',
      
      // Header
      hospitalOnboarding: 'Hospital Onboarding',
      comprehensiveHospitalProfile: 'Comprehensive Hospital Profile',

      // Section 1: Profile
      profile: 'Profile',
      profileDescription: 'Corporate legal details & authorized signatories',
      addDesignatedEmployee: 'Add Designated Employee',
      hospitalType: 'Hospital Type',
      soleProprietorship: 'Sole Proprietorship',
      partnership: 'Partnership',
      privateLimited: 'Private Limited',
      llp: 'LLP',
      trust: 'Trust',
      others: 'Others',
      specifyHospitalType: 'Specify Hospital Type',
      partnerNames: 'Partner Names',
      directorNames: 'Director Names',
      addPartner: 'Add Partner',
      addDirector: 'Add Director',
      authorizedSignatoryName: 'Authorized Signatory Name',
      signatoryPhone: 'Signatory Phone (WhatsApp)',
      officialEmailId: 'Official Email ID',

      // Section 2: Facility Location & Licenses
      facilityLocation: 'Facility Location & Licenses',
      facilityDescription: 'Physical facility maps, license credentials and online presence',
      fullFacilityAddress: 'Full Facility Address',
      city: 'City',
      district: 'District',
      state: 'State',
      pincode: 'Pincode',
      clinicalRegistration: 'Clinical Registration',
      regNumber: 'Reg Number',
      uploaded: 'Uploaded',
      uploadCert: 'Upload Cert',
      regCopyAttached: '✓ Reg Copy Attached',
      issuingAuthority: 'Issuing Authority',
      licenseExpiry: 'License Expiry',
      digitalPhysicalPresence: 'Digital & Physical Presence',
      googleMapsLink: 'Google Maps Link',
      websiteUrl: 'Website URL',
      facilityPhotoLogo: 'Facility Photo / Logo',
      uploadPhoto: 'Upload Photo',
      digitalSignature: 'Digital Signature',
      uploadSignature: 'Upload Signature',
      signatureDescription: 'Authorized signatory signature for MoU agreement',
      signatureFileHint: 'JPG, PNG accepted — Clear background preferred',
      whyRequired: 'Why is this required?',
      signatureWhyDescription: 'This signature will appear on the MoU Agreement between your hospital and Hedena Healthcare. It confirms the authorized signatory\'s consent.',

      // Section 3: Infrastructure & Accreditation
      infrastructureAccreditation: 'Infrastructure & Accreditation',
      infrastructureDescription: 'Details about hospital beds, operation theaters, and certifications',
      totalBedCapacity: 'Total Bed Capacity',
      icuBeds: 'ICU Beds',
      operationTheaters: 'Operation Theaters',
      emergencyServices: 'Emergency Services',
      nabhAccredited: 'NABH Accredited',
      ayushmanBharat: 'Ayushman Bharat',
      ayushmanBharatEmpanelled: 'Ayushman Bharat',
      upload: 'Upload',
      nabhProofAttached: '✓ NABH Proof Attached',
      ayushmanProofAttached: '✓ Ayushman Proof Attached',

      // Section 4: KYC & Financials
      kycFinancials: 'KYC & Settlement Financials',
      kycDescription: 'Corporate taxation data and bank verification credentials',
      entityPanNumber: 'Entity PAN Number',
      uploadPan: 'Upload PAN',
      panCopyAttached: '✓ PAN Copy Attached',
      hasGstin: 'Has GSTIN?',
      yes: 'Yes',
      no: 'No',
      gstCertificateAttached: '✓ GST Certificate Attached',
      uploadBankProofShort: 'Upload Bank Proof',

      // Footer
      cancel: 'Cancel',
      onboarding: 'Onboarding...',
      completeHospitalOnboarding: 'Complete Hospital Onboarding',
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React escapes values automatically
    },
  });

export default i18n;
